/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Hero_H1_BeforeInputs */

const es_exp_mk_hero_h1_before = /** @type {(inputs: Exp_Mk_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte la salida. Comparte el `)
};

const gl_exp_mk_hero_h1_before = /** @type {(inputs: Exp_Mk_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte a saída. Comparte o `)
};

const en_exp_mk_hero_h1_before = /** @type {(inputs: Exp_Mk_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share the trip. Share the `)
};

/**
* | output |
* | --- |
* | "Share the trip. Share the" |
*
* @param {Exp_Mk_Hero_H1_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_hero_h1_before = /** @type {((inputs?: Exp_Mk_Hero_H1_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Hero_H1_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_hero_h1_before(inputs)
	if (locale === "en") return en_exp_mk_hero_h1_before(inputs)
	return es_exp_mk_hero_h1_before(inputs)
});